import { http } from '@/utils/axios'

// 获取直播课课列表
export function getLiveTableList() {
    return http({
        url: http.baseUrl('index.php?app=live&mod=AdminLive&act=getList'),
        method: 'get',
        // params: http.params(data)
    })
}

// 获取直播课课待审核列表
export function getWaitTableList() {
    return http({
        url: http.baseUrl('index.php?app=live&mod=AdminLive&act=getList&type=2'),
        method: 'get',
        // params: http.params(data)
    })
}

// 获取直播课课回收站列表
export function getDelTableList() {
    return http({
        url: http.baseUrl('index.php?app=live&mod=AdminLive&act=getList&type=3'),
        method: 'get',
        // params: http.params(data)
    })
}


// 直播课搜索
export function selectTableList(data) {
    return http({
        url: http.baseUrl('index.php?app=live&mod=AdminLive&act=getList'),
        method: 'post',
        data: http.data(data)
    })
}

// 禁用列表
export function DisablesClass(data) {
    return http({
        url: http.baseUrl('index.php?app=live&mod=AdminLive&act=delLive'),
        method: 'post',
        data: http.params(data)
    })
}

// 获取直播课数据
export function getLiveTableListById(data) {
    return http({
        url: http.baseUrl('index.php?app=live&mod=AdminLive&act=getLiveClass'),
        method: 'get',
        params: http.params(data)
    })
}

// 添加/编辑保存直播课数据
export function addLineCLass(data) {
    return http({
        url: http.baseUrl('index.php?app=live&mod=AdminLive&act=saveLiveClass'),
        method: 'post',
        data: http.params(data)
    })
}

// 启用面授课
export function reOpenLine(data) {
    return http({
        url: http.baseUrl('index.php?app=live&mod=AdminLive&act=reOpenLive'),
        method: 'post',
        data: http.data(data)
    })
}

// 获取建课讲师
export function getTeacherList(data) {
    return http({
        url: http.baseUrl('index.php?app=course&mod=AdminLineClass&act=getTeachers'),
        method: 'get',
        params: http.params(data)
    })
}

// 获取建课学校
export function getSchoolList(data) {
    return http({
        url: http.baseUrl('index.php?app=course&mod=AdminLineClass&act=getSchools'),
        method: 'get',
        params: http.params(data)
    })
}

// 获取课程资源库
export function getwaresList(data) {
    return http({
        url: http.baseUrl('index.php?app=course&mod=AdminLineClass&act=getWares'),
        method: 'get',
        params: http.params(data)
    })
}

// 获取承诺书
export function getUnderTakingsList(data) {
    return http({
        url: http.baseUrl('index.php?app=course&mod=AdminLineClass&act=getUnderTakings'),
        method: 'get',
        params: http.params(data)
    })
}

// 获取报名信息
export function getSignUpInfosList(data) {
    return http({
        url: http.baseUrl('index.php?app=course&mod=AdminLineClass&act=getSignUpInfos'),
        method: 'get',
        params: http.params(data)
    })
}